export default {
  title01: "वर्तमान मौसम",
  title02: "24 घंटे",
  title03: "10-दिन का मौसम पूर्वानुमान देखें",
  title04: "AQI",
  title05: "सभी जानकारी देखें",
  title06: "सूर्योदय और सूर्यास्त",
  title07: "चंद्रमा का चरण",
  title08: "अगली पूर्णिमा",
  title09: "अगला अमावस्या",
  title10: "दिन",
  title11: "रात",
  title12: "सूर्योदय",
  title13: "सूर्यास्त",
  title14: "चंद्रोदय",
  title15: "चंद्रास्त",
  title16: "स्रोत",
  title17: "शुरू",
  title18: "अंत",
  title19: "वर्तमान स्थान का उपयोग",
  title20: "शहर खोजें",
  title21: "रियलफील",
  title22: "रियलफील शेड",
  title23: "अभी",
  title24: "आज",
  title25: "रवि",
  title26: "सोम",
  title27: "मंगल",
  title28: "बुध",
  title29: "बृहस्पति",
  title30: "शुक्र",
  title31: "शनि",
  title32: "लोडिंग...",
  title33: "अभी",
  title34: "घंटा",
  title35: "प्रतिदिन",
  title36: "सूर्य और चाँद",
  title37: "हवा की गुणवत्ता",
  title38: "संपर्क करें: xlf50402@gmail.com",
  title39: "गोपनीयता समझौता",
  title40: "कॉपीराइट comfortweather.com 2020-2026 . सभी अधिकार सुरक्षित ",
  title41: "डेटा द्वारा उपलब्ध कराया गया",
  title42: "उच्चतम तापमान",
  title43: " न्यूनतम तापमान",
  title44: "स्वीकार करना",
  title45:
    "ComfortWeather का उपयोग करने के लिए धन्यवाद! अपने कानूनी अधिकारों और हितों की बेहतर सुरक्षा के लिए, कृपया उपयोग करने से पहले ",
  title46: "गोपनीयता नीति",
  title47: " को ध्यान से पढ़ें।",
  title48: "",
  title49: "संपर्क करें: xyjph123@gmail.com",
  title50: "कॉपीराइट 24hweather.com 2020-2026 . सभी अधिकार सुरक्षित ",
  title51:
    "24hweather का उपयोग करने के लिए धन्यवाद! अपने कानूनी अधिकारों और हितों की बेहतर सुरक्षा के लिए, कृपया उपयोग करने से पहले ",
  title52: "आपका स्थान बदल गया है। क्या आप इसे अपडेट करना चाहते हैं?",
  title53: "पुष्टि करना",
  title54: "4रद्द करना",
  title55: "पीछे",
  title56: "समाचार",
  title57: "मौसम अपडेट करना",
  title58: "मौसम अपडेट",
  title59: "सभी को देखें",
  title60: "कॉपीराइट mobi321.com 2020-2026 . सभी अधिकार सुरक्षित ",
  title61: "कल",
  title62: "परसों",
  title63: "15-दिन का मौसम पूर्वानुमान देखें",
  title64: "आज का विवरण",
  title65: "राहु काल",
  title66: "जीवनशैली सूचकांक",
  title67: "जीवनशैली सूचकांक",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "सुखाना मुश्किल",
  title103: "धीमा सुखना",
  title104: "अच्छी तरह सूखते हैं",
  title105: "तेज़ी से सूखते हैं",
  title106: "बहुत तेज़ी से सूखते हैं",

  title107: "उपयुक्त नहीं",
  title108: "ठीक-ठाक अनुभव",
  title109: "पानी में मस्ती के लिए अच्छा",
  title110: "बहुत उपयुक्त",
  title111: "एकदम आदर्श परिस्थितियाँ",

  title112: "स्वास्थ्य के लिए अनुकूल",
  title113: "तटस्थ परिस्थितियाँ",
  title114: "जोखिम थोड़ा अधिक",
  title115: "उच्च जोखिम",
  title116: "अत्यधिक जोखिम",

  title117: "उपयुक्त नहीं",
  title118: "कुछ हद तक उपयुक्त",
  title119: "बाहर के लिए अच्छा",
  title120: "बहुत उपयुक्त",
  title121: "बेहतरीन परिस्थितियाँ",

  title122: "बहुत अधिक शुष्क स्थिति",
  title123: "शुष्क होने की संभावना",
  title124: "थोड़ी शुष्क",
  title125: "शुष्क होने की संभावना कम",
  title126: "शुष्क होने की संभावना बहुत कम",

  title127: "सिफारिश नहीं की जाती",
  title128: "ठीक-ठाक",
  title129: "अच्छा दिन",
  title130: "बहुत अच्छी परिस्थितियाँ",
  title131: "आदर्श परिस्थितियाँ",
};
